'use strict';

module.exports = {
  template: require('./django-form.html'),
  controller: require('./django-form.controller'),
  controllerAs: 'vm',

  bindings: {
    url: '@',
    method: '@',
    formClass: '@',
    labelClass: '@',
    fieldClass: '@',
    buttonSpinner: '<',
    onSubmit: '<',
    hiddenFields: '<'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/django-form/index.js
 ** module id = 45
 ** module chunks = 0
 **/